import React, { useState, useEffect } from 'react';
import { Container, Row, Col, ListGroup, Button } from 'react-bootstrap';
import Section from '../../../Shared/Sections/Section';
import applicationService, { getSections } from "../../../../services/Internal/Application/EF/efApplication.service";
import InternalTaskInfo from '../../Shared/InternalTaskInfo';
import { useDispatch, useSelector } from 'react-redux';
import Information from '../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../Shared/InformationContent/EFInformation';
import entityService from '../../../../services/Internal/Staff/entity.service';
import Swal from 'sweetalert2';
import FormEntityInformation from '../../Shared/FormEntityInformation';
import recentQueueService from '../../../../services/Internal/Recent/recentQueue.service'
import issuesService from '../../../../services/Shared/issues.service';
import spService from '../../../../services/supervisingProfessional.service';

function Index() {
    const marginRight = {
        marginRight: '1rem'
    }
    const [showSectionButton, setShowSectionButton] = useState(true);
    const [justLicensed, setJustLicensed] = useState(false);
    const [sections, setSections] = useState(null);
    const [spSectionId, setSpSectionId] = useState(null);//when the task is approved we need to parent SP attestations to the section
    const dispatch = useDispatch();
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            user: '',
            entityId: 0
        }
    );
    const [credInfo, setCredInfo] = useState({
        licenseNumber: "",
        applicationDate: ""
    });
    const [hasLoaded, setHasLoaded] = useState(false);
    const selector = useSelector(x => x);
    useEffect(() => {
        var routes = JSON.parse(localStorage.getItem('PERSIST_CURRENT_ROUTE')) ?? selector.currentRoutes;
        var currentAppId = localStorage.getItem('PERSIST_CURRENT_APP_ID') ?? selector.currentApplicationId;
        var currentEntityID = localStorage.getItem('PERSIST_CURRENT_APP_ENTITY_ID') ?? selector.currentApplicationEntityId;
        var currentAppTypeId = localStorage.getItem('PERSIST_CURRENT_APP_TYPE_ID') ?? selector.currentApplicationTypeId;
        if (localStorage.getItem('PERSIST_CURRENT_APP_ID')) {
            localStorage.removeItem('PERSIST_CURRENT_ROUTE');
            localStorage.removeItem('PERSIST_CURRENT_APP_ID');
            localStorage.removeItem('PERSIST_CURRENT_APP_ENTITY_ID');
            localStorage.removeItem('PERSIST_CURRENT_APP_TYPE_ID');

            dispatch({ type: "PERSIST_CURRENT_ROUTE", payload: routes });
            dispatch({ type: "PERSIST_CURRENT_APP_ID", payload: currentAppId });
            dispatch({ type: "PERSIST_CURRENT_APP_ENTITY_ID", payload: currentEntityID });
            dispatch({ type: "PERSIST_CURRENT_APP_TYPE_ID", payload: currentAppTypeId });
        }
        //Add to recent Queue
        recentQueueService.updateRecentQueue({
            entityId: currentEntityID,
            parentId: currentAppId,
            parentTypeId: 2,
            appTypeId: 7,
            routes: JSON.stringify(routes)
        }).then((data) => {
            var token = parseInt(localStorage.getItem('updateRecentQueue')) ? parseInt(localStorage.getItem('updateRecentQueue')) : 0;
            localStorage.setItem('updateRecentQueue', token + 1)
            dispatch({ type: "PERSIST_CURRENT_RECENT_QUEUE", payload: parseInt(localStorage.getItem('updateRecentQueue')) });
        })
        entityService.getEntity(currentEntityID).then((entity) => {
            setEntityInfo(
                {
                    lolaNum: entity.data.lolaNumber,
                    user: entity.data.formattedName,
                    entityId: entity.data.entityId
                })
        });
        applicationService.getFirmApplication(currentAppId).then((sectionResponse) => {
            setHasLoaded(true);
            setCredInfo({
                licenseNumber: sectionResponse.data?.credential?.formattedLicenseNumber,
                applicationDate: sectionResponse.data?.dateSubmitted
            })
            if (sectionResponse.data.sections.findIndex((element) => element.staffReviewComplete === false) !== -1 || sectionResponse.data.status.id !== 2) {// status id 2 = pending
                setShowSectionButton(false);
            }
            setSpSectionId(sectionResponse.data.sections.find((element) => element.sectionType?.id == 14)?.id)
            getSections().then((response) => {
                issuesService.getIssuesForSections(1, currentAppId).then((data) => {
                    setSections(routes != null ? routes.map((value, i) => {
                        var section = {
                            ...response.filter(x => x.id == value.sectionId)[0]
                        };
                        if (section?.id) {
                            section.link = value.route
                            var index = sectionResponse.data.sections.findIndex(x => x.sectionType?.id == section.id);
                            if (index !== -1) {
                                var issues = data.data.filter(x => x.sectionId == section.id);
                                if (sectionResponse.data.sections[index].staffReviewComplete)
                                    section.status = "COMPLETE";
                                else if (issues.length) {
                                    section.status = `${issues[0].openIssueCount} Issue${issues[0].openIssueCount > 1 ? 's' : ''}`;
                                }
                                return <Section data={{ ...section }} key={i} />
                            }

                            return <Section data={section} key={i} />
                        }
                        return;
                    }) : []);
                })
            })
        })
    }, [])
    const sendStaffApproval = (isApproved) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to ${isApproved ? 'license' : 'decline'} this application? You won't be able to revert this!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue!'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: `${isApproved ? 'Licensing' : 'Declining'} Application`,
                    didOpen: () => {
                        Swal.showLoading();
                        applicationService.postStaffApproval(selector.currentApplicationId, isApproved).then((response) => {
                            if (response.data) {
                                setShowSectionButton(false);
                                Swal.fire({
                                    title: `Saving PDF`,
                                    didOpen: () => {
                                        Swal.showLoading();
                                        applicationService.postApplicationPdf(response.data.id, isApproved).then((data) => {
                                            spService.postSpAttestationsPdf(spSectionId, 1, entityInfo.entityId, 1).then((pdfResult) => {
                                                if (data.data) {
                                                    setJustLicensed(true);
                                                    Swal.fire("Saved", `The application was successfully ${isApproved ? 'approved' : 'declined'}!`, "success")
                                                }
                                            })
                                        })
                                    },
                                    allowOutsideClick: false
                                })
                            }
                        })
                    },
                    allowOutsideClick: false
                })
            }
        })
    }

    return (
        <div className="efApplicationIndexPage">
            <Container fluid>
                <FormEntityInformation
                    formType="Engineering Firm Application"
                    isIndividual={false}
                    entityId={entityInfo.entityId}
                    entityName={entityInfo.user}
                    licenseNumber={credInfo.licenseNumber}
                    lolaNum={entityInfo.lolaNum}
                    applicationDate={credInfo.applicationDate}
                />
                <br />
                <Row>
                    <Col><Information content={GetAppInformationContent("index")} /></Col>
                </Row>
                <br />
                {hasLoaded &&
                    <InternalTaskInfo justLicensed={justLicensed} parentTypeId={2} parentId={selector.currentApplicationId} />
                }
                <Row>
                    <Col>
                        <h4 className="mb-3">Sections to Complete</h4>
                        <ListGroup>
                            {sections}
                        </ListGroup>
                    </Col>
                </Row>
                {showSectionButton &&
                    <div className="float-end" style={{ marginTop: '1rem' }}>
                        <Button name="approveBtn" type="submit" variant="success" onClick={() => { sendStaffApproval(true) }} style={marginRight}>License</Button>
                        <Button name="disapproveBtn" variant="danger" onClick={() => { sendStaffApproval(false) }} style={marginRight}>Decline</Button>
                    </div>
                }
            </Container>
        </div>
    )
}
export default Index;